import { css } from 'lit';

export const style = css`
  .large-spacer {
    height: 24px;
  }

  .medium-spacer {
    height: 16px;
  }

  .refi-contract-error-ui {
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
  }

  .error-img {
    display: flex;
    height: 96px;
    margin: auto;
    padding: 17.61px 14.325px 17.85px 13.765px;
    width: 96px;
  }

  @media only screen and (max-width: 374px) {
    .bau-error-text {
      width: 263px;
    }

    .error-text {
      width: 272px;
    }
  }

  @media only screen and (min-width: 375px) and (max-width: 768px) {
    .bau-error-text {
      width: 283px;
    }

    .error-text {
      width: 327px;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 1727px) {
    .error-text,
    .bau-error-text {
      width: 500px;
    }
  }

  @media only screen and (min-width: 1728px) {
    .error-text,
    .bau-error-text {
      height: auto;
      width: 542px;
    }
  }
`;
